export const swedishTranslation = {
  'Account recovery requires verified contact information':
  'Återställning av konto kräver verifierad kontaktinformation',
  'Back to Sign In': 'Tillbaka till inloggning',
  'Change Password': 'Ändra lösenord',
  Code: 'Kod',
  Confirm: 'Bekräfta',
  'Confirm a Code': 'Bekräfta koden',
  'Confirm Password': 'Bekräfta lösenord',
  'Confirm Sign In': 'Bekräfta inloggning',
  'Confirm Sign Up': 'Bekräfta registrering',
  'Confirmation Code': 'Kod',
  'Create a new account': 'Skapa konto',
  Email: 'E-post',
  'Forgot Password': 'Glömt lösenordet?',
  'Incorrect username or password': 'Felaktigt användardnamn eller lösenord',
  'Invalid password format': 'Ogiltigt format på lösneordet',
  'Invalid phone number format': 'Ogilitigt telefonnummer',
  'Loading...': 'Laddar...',
  'New Password': 'Nytt lösenord',
  or: 'eller',
  Password: 'Lösenord',
  'Phone Number': 'Telefonnummer',
  'Resend a Code': 'Skicka en kod igen',
  'Resend Code': 'Skicka koden igen',
  'Reset your password':'Återställ lösenord',
  'Send Code': 'Skicka kod',
  'Send code': 'Skicka kod',
  'Sign In': 'Logga in',
  'Sign in': 'Logga in',
  'Sign in to your account': 'Logga in',
  'Sign Out': 'Logga ut',
  'Sign Up': 'Skapa konto',
  Skip: 'Hoppa över',
  Submit: 'Ok',
  'User already exists': 'Användaren finns redan',
  'User does not exist': 'Användaren finns inte',
  Username: 'Användarnamn',
  'Username cannot be empty': 'Användarnamnet kan inte vara tomt',
  Verify: 'Verifiera',
  'Verify Contact': 'Verifiera kontaktinformation',
  'Create Account':'Registrera',
  'Forgot your password? ':'Glömt lösenordet?',
  'Your passwords must match':'Lösenorden matchar inte',
  'Name':'Namn',
  'Signing in': 'Loggar in...'
};
